<template>
  <v-dialog persistent :value="true" dark scrollable>
    <v-card dark>
      <v-form lazy-validation v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" align="center">
              <h1 class="my-6 text-center white--text text-uppercase" style="font-size: 1.5vh">
                Please Enter a correct 3POS URL
              </h1>
              <v-textarea
                  v-model="urlString"
                  autofocus
                  dark
                  rows="5"
                  class="input my-2 pa-5 pb-0"
                  label="URL"
                  outlined
                  :rules="[rules.isValidUrl]"
              />
              <v-btn
                  color="primary"
                  x-large
                  :disabled="!valid"
                  @click="setAuthConfig"
              >
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "AuthDialog",
  data() {
    return {
      urlString: null,
      valid: false,
      rules: {
        isValidUrl(val) {
          try {
            let url = new URL(val);
            if(url.searchParams.get("bsid") && url.searchParams.get("bs"))
              return true;

            return 'Please enter a valid 3POS URL';
          } catch (err) {
            return 'Please enter a valid 3POS URL';
          }
        }
      }
    }
  },
  methods: {
    setAuthConfig() {
      let url = new URL(this.urlString)
      let bs = url.searchParams.get("bs")
      let bsid = url.searchParams.get("bsid");


      let socketServerIP = url.protocol + "//" + url.host;
      this.$socket.io.uri = socketServerIP;

      this.$socket.io.opts.query = {
        bs: bs,
        bsid: bsid,
        clientName: "Pickup_Monitor",
        userID: 0,
        clientType: 2
      };

      this.$socket.open()

      this.$socket.emit("pickupMonitor.refreshOrders");

      this.$store.commit('setAuth',{
        bsid: bsid,
        bs: bs,
        socketServer : socketServerIP,
      })
    }
  }
}
</script>

<style scoped>

</style>